import { render, staticRenderFns } from "./FiltroAreaAcao.vue?vue&type=template&id=7aebef31&scoped=true"
import script from "./FiltroAreaAcao.vue?vue&type=script&lang=js"
export * from "./FiltroAreaAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aebef31",
  null
  
)

export default component.exports